/** @format */

import {WidgetStat} from 'components/PropertyWidget/model';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

interface Options {
  data: Space;
  widgetId: ChartIds;
  custom: Record<string, unknown>;
  stats: WidgetStat[];
  saveSpaceSettings: (space: Space) => void;
}

const updateWidgetCustom = ({data, widgetId, custom, stats, saveSpaceSettings}: Options): Space => {
  const oldSettings = data.widgetsSettings[widgetId] || {};
  const newSpace: Space = {
    ...data,
    widgetsSettings: {
      ...data.widgetsSettings,
      [widgetId]: {
        ...oldSettings,
        custom,
        stats,
      },
    },
  };
  saveSpaceSettings(newSpace);
  return newSpace;
};

export default updateWidgetCustom;
